exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-invite {\n  position: absolute;\n  display: inline-flex;\n  justify-content: flex-end;\n  right: 32px;\n  z-index: 10;\n}\n", ""]);

// exports
